import {
  CONFIG_PRODUCTS as PRODUCTS_MAPPER,
  type ProductKeys,
} from '@/legacy/components/Products/constants'

import { getFormattedDates } from '@/legacy/core/utils/dom/getFormattedDate'

interface GetLabelsProps {
  product?: ProductKeys
  date?: number | string
  readingTime?: string
}

export const getLabels = (props: GetLabelsProps) => {
  const formattedDate = (props.date && getFormattedDates(props.date)) || undefined

  const ACCESSIBLE_LABELS = {
    product: `${props.product && `produto ${PRODUCTS_MAPPER[props.product].name}`}`,
    publication: `Data de publicação ${formattedDate?.accessible}`,
    readingTime: `${props.readingTime} de leitura`,
  }
  return { ACCESSIBLE_LABELS, formattedDate }
}
